import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Input, SearchIcon, Table, TableHead, TableBody, TableRow,
    TableHeaderCell,
    TableCell,
    RadioButton,
    TextOverflow,
    Button
} from "@forge/common";
import { mountISOFile } from "../store/create-course.action";
import { IMountISOProps, IVAPPVMTableHeader } from "../model/index";
import { dateFormatFun, rendererFileSizeCol } from "../../file-management/utils/helper";
import config from "../../../../../common/authentication/config";
const MountISOComponent: React.FC<IMountISOProps> = ({
    handleMountISOChange,
    selectedVmForInsertEject,
    courseSiteId,
    courseOrgId,
    isoTableData
}) => {
    const dispatch = useDispatch();
    const [selectedISO, setSelectedISO] = useState<any>(null);
    const [mediaList, setMediaList] = useState<any[]>(isoTableData || []);
    const [filteredMediaList, setFilteredMediaList] = useState<any[]>(isoTableData || []);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const mountIsoTableHeaders: IVAPPVMTableHeader[] = [
        { id: "name", name: "NAME" },
        { id: "creationDate", name: "CREATION DATE" },
        { id: "description", name: "DESCRIPTION" },
        { id: "storage", name: "STORAGE" },
    ];
    useEffect(() => {
        if (isoTableData.length > 0) {
            setMediaList(isoTableData);
            setFilteredMediaList(isoTableData);
        } else {
            setMediaList([]);
            setFilteredMediaList([]);
        }
    }, [isoTableData]);
    const handleSearchChange = (e: any) => {
        const query = e.target.value || "";
        setSearchQuery(query);

        // If search is empty, show all data
        if (!query.trim()) {
            setFilteredMediaList(mediaList);
            return;
        }

        const lowercasedQuery = query.trim().toLowerCase();

        // Filter by name or description
        const filtered = mediaList.filter((item) => {
            const name = item.name?.toLowerCase() || "";
            const description = item.description?.toLowerCase() || "";

            return name.includes(lowercasedQuery) || description.includes(lowercasedQuery);
        });

        setFilteredMediaList(filtered);
    };
    const onItemSelect = (data: any) => {
        const { checked, ...isoData } = data;
        setSelectedISO(isoData);
    };

    const handleInsertMedia = () => {
        dispatch(
            mountISOFile({
                vmId: [`vm-${selectedVmForInsertEject}`],
                authorization: localStorage.getItem("access_token"),
                siteId: config?.SITE_ID,
                orgId: courseOrgId,
                isoData: selectedISO,
                tenantId: config?.ACADEMY_TENANT_ID
            })
        );
    };
    return (
        <div>
            <div className="grid grid-cols-2 gap-2 items-center w-full">
                <div className="col-span-1 !p-0">
                    <Input
                        id="search-input-vAppName"
                        data-testid="search-input-vAppName"
                        className="search-template-input-field !w-[270px]"
                        placeholder={`Search iso by name and description`}
                        onChange={(e) => handleSearchChange(e)}
                        prefix={<SearchIcon strokeWidth={2} />}
                        size="regular"
                        autoComplete="off"
                        value={searchQuery}
                    />
                </div>
            </div>
            <div className="mt-4 flex-1 overflow-hidden">
                <div className="h-[247px] overflow-y-auto">
                    <Table onCard>
                        <TableHead>
                            <TableRow>
                                <TableHeaderCell
                                    id="iso-select-cell"
                                    className="vpp-table-border max-w-[40px]"
                                ></TableHeaderCell>
                                {mountIsoTableHeaders.map((header: IVAPPVMTableHeader) => (
                                    <TableHeaderCell
                                        className="text-sm vpp-table-border !max-w-[110px]"
                                        key={header.id}
                                        id={header.id}
                                        data-testid={header.name}
                                    >
                                        {header.name}
                                    </TableHeaderCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredMediaList.length > 0 &&
                                filteredMediaList.map((data, i) => {
                                    const isSelected = selectedISO?.mediaId === data.mediaId;
                                    return (
                                        <TableRow id={`iso-row-${i}`} selected={isSelected} key={i}>
                                            <TableCell id={`select-iso-id-${i}`} className="table-body-cell !max-w-[40px]">
                                                <RadioButton
                                                    className="text-sm cursor-pointer"
                                                    data-testid={`iso-row-${i}-select`}
                                                    id={`iso-row-${i}-select`}
                                                    value={data.mediaId}
                                                    name="iso-selection"
                                                    checked={isSelected}
                                                    onChange={() => onItemSelect(data)}
                                                />
                                            </TableCell>
                                            <TableCell className="table-body-cell !max-w-[130px]">
                                                <TextOverflow>{data.name ? data.name : '--'}</TextOverflow>
                                            </TableCell>
                                            <TableCell className="table-body-cell !max-w-[130px]">
                                                <TextOverflow>{data.creationDate ? dateFormatFun(data.creationDate) : '--'}</TextOverflow>
                                            </TableCell>
                                            <TableCell className="table-body-cell !max-w-[130px]">
                                                <TextOverflow>{data.description ? data.description : '--'}</TextOverflow>
                                            </TableCell>
                                            <TableCell className="table-body-cell !max-w-[100px]">
                                                <TextOverflow>{data.storageB ? rendererFileSizeCol(data.storageB) : '--'}</TextOverflow>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {filteredMediaList.length === 0 && (
                                <TableRow>
                                    <TableCell
                                        colSpan={5}
                                        className="text-center !border-none"
                                    >
                                        <div className="min-h-32">
                                            <p className="text-center text-sm font-bold vpp-table-border">
                                                No data found
                                            </p>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </div>
            <div className="display flex justify-end mt-4">
                <Button
                    className="text-base font-w-700 mr-4"
                    id="cancel-insert-media"
                    data-testid="cancel-insert-media"
                    onClick={handleMountISOChange.bind(this, false, {})}
                    size="regular"
                    variant="secondary"
                    iconPosition="right"
                >
                    {'CANCEL'}
                </Button>
                <Button
                    className="text-base font-w-700 mr-4"
                    id="insert-media"
                    data-testid="insert-media"
                    onClick={() => handleInsertMedia()}
                    size="regular"
                    variant={'primary'}
                    iconPosition="right"
                    disabled={!selectedISO}
                >
                    {'INSERT MEDIA'}
                </Button>
            </div>
        </div>
    );
}
export default MountISOComponent;